import React, { FC } from 'react'
import { ResourceRowContainer } from './style'

//* Components
import Button from '../../global/button'
import GlobalContainer from '../globalContainer'
import Typography from '../typography'
import { GenerateCard } from './subcomponents/generateCard'

//* utils
import { ComponentResourceRow } from '../../../models/components/resourceRow'
import { internalLinkHandler } from '../../../utils/link.utils'

type Props = {
  data: ComponentResourceRow
  pageType: string
  isHomePage?: boolean
  locale: string
}

const ResourceRow: FC<Props> = ({ data, pageType, isHomePage = false, locale }) => {
  const resourceRowData = {
    microcopyset: data.microcopyset || [],
    seeAllItemsIntro: data.seeAllItemsIntro || '',
    seeAllItemsCta: data.seeAllItemsCta || {},
    featuredPages: data.featuredPages || [],
    topPadding: data.topPadding || 'Large',
    bottomPadding: data.bottomPadding || 'Large',
    hideCtas: data.hideCtas || false,
    useCase: data.useCase || '',
    noMedia: data.noMedia || false,
    theme: data.theme || 'Grey',
  }

  const href = resourceRowData.seeAllItemsCta.internalLink
    ? internalLinkHandler(resourceRowData.seeAllItemsCta.internalLink)
    : resourceRowData.seeAllItemsCta.externalUrl

  const usecaseClass = () => {
    if (resourceRowData.useCase === 'Full width')
      return 'resourceRow--fullWidth ResourceRowContainer'
    else if (resourceRowData.useCase === 'Four cards')
      return 'resourceRow--fourCards ResourceRowContainer'
    else return 'ResourceRowContainer'
  }

  const featuredPages = resourceRowData.featuredPages
  let featuredPagesArray

  if (resourceRowData.useCase === 'Four cards') {
    featuredPagesArray =
      featuredPages.length > 4
        ? resourceRowData.featuredPages.slice(0, -1)
        : resourceRowData.featuredPages
  } else {
    featuredPagesArray =
      featuredPages.length > 3
        ? resourceRowData.featuredPages.slice(0, -1)
        : resourceRowData.featuredPages
  }
  return (
    <ResourceRowContainer
      data-cy={`ResourceRow${isHomePage ? '-Homepage' : ''}`}
      $topPadding={resourceRowData.topPadding}
      $bottomPadding={resourceRowData.bottomPadding}
      $theme={resourceRowData.theme}
      $isHomePage={isHomePage}
      $pageType={pageType}
      className={usecaseClass()}>
      <GlobalContainer className="ResourceRow__Outer-Container">
        <div className="ResourceRow__Card-Container">
          {featuredPagesArray?.map((element: any, index: number) => (
            <GenerateCard
              key={`ResourceRowItem--${index}`}
              item={element}
              resourceRowData={resourceRowData}
              isHomePage={false}
              locale={locale}
              index={index}
            />
          ))}
        </div>

        {resourceRowData.seeAllItemsIntro && (
          <Typography type="bodyXS" className="ResourceRow__SeeAllItemsIntro font__inter">
            {resourceRowData.seeAllItemsIntro}
          </Typography>
        )}

        {resourceRowData.seeAllItemsCta.text && (
          <div className="ResourceRow__CTA-Container">
            {resourceRowData.useCase === 'Full width' ||
            resourceRowData.useCase === 'Four cards' ? (
              <Button
                icon={true}
                href={href}
                text={resourceRowData.seeAllItemsCta.text}
                type="text-link"
                size="small"
                theme={'light'}
              />
            ) : (
              <Button
                icon={true}
                href={href}
                text={resourceRowData.seeAllItemsCta.text}
                type="tertiary"
                size="small"
                theme={'light'}
              />
            )}
          </div>
        )}
      </GlobalContainer>
    </ResourceRowContainer>
  )
}

export default ResourceRow
